export default __webpack_public_path__ + "static/media/princeofterror.f1c63c88.png";